import { RemoteData } from 'app/infrastructure/remote-data/index';
import { endpoint as favouriteEndpoint } from 'app/area/favourite/constants';
import { RenderMode } from 'app/types-shared';

export const api = {

  createSearchForCasesToConnect: async (id: number, connectionTypeId: number,  renderMode?: RenderMode): Promise<number> => {
    const result = await new RemoteData(`${favouriteEndpoint.connectedCasesFavouriteDefinition}`)
      .resource<any>()
      .filter({
        ...(renderMode === 0
        ? { caseId: id }
        : { caseDraftId: id }),
        connectionTypeId
      })
      .create(undefined);
    const obj = await result.json();
    return obj.data;
  }

};
